/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentProfileDna } from '../../models/student-profile-dna';

export interface GetStudentDnaHistory$Params {
  profileId: string;
  Label?: string;
}

export function getStudentDnaHistory(http: HttpClient, rootUrl: string, params: GetStudentDnaHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StudentProfileDna>>> {
  const rb = new RequestBuilder(rootUrl, getStudentDnaHistory.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.query('Label', params.Label, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StudentProfileDna>>;
    })
  );
}

getStudentDnaHistory.PATH = '/studentprofile/{profileId}/dna';
